const decimals = (n: number) => {
  const s = String(n)
  const i = s.indexOf('.')
  return i === -1 ? 0 : s.length - i - 1
}

// suma con redondeo al # máximo de decimales presente en la data
export const sumWithDynamicScale = (values: number[]) => {
  const maxDp = values.reduce((m, v) => Math.max(m, decimals(v)), 0)
  if (maxDp === 0) return values.reduce((a, b) => a + b, 0)

  const factor = Math.pow(10, maxDp)
  const intSum = values.reduce((acc, v) => acc + Math.round(v * factor), 0)
  return intSum / factor
}
